import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, /*Input,*/ Button, Icon, Alert } from 'antd'
import { sendNotification } from '../../utils/index'
import { changePasswordUser } from '../../actions/UsersAction'
import { PasswordInput } from 'antd-password-input-strength'

export class ChangePassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      password: '',
      confirm: '',
      allowChangePassword: false
    }
  }
  componentDidMount() {
    this.verifyUserRole();
  }

  verifyUserRole = () => {
    const { user, data } = this.props;
    if(!user) return;
    if (user.role === 'admin') {
      this.setState({
        allowChangePassword: true
      })
    } else {
      if(!data) return;
      if (user.clientRole === 'admin' && data.role === 'operator') {
        this.setState({
          allowChangePassword: true
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { isChangingPassword, showChangePassword } = this.props
    if (prevProps.isChangingPassword && !isChangingPassword) {
      this.props.close()
    }
    if(showChangePassword !== prevProps.showChangePassword && showChangePassword){
      this.verifyUserRole();
    }
  }

  handleOnInputChange = (e) => {
    const { password, confirm } = this.state
    this.setState({
      [e.target.name]: e.target.value,
      isEnabled: password !== '' && confirm !== ''
    })
  }


  handleSubmit = e => {
    const { password, confirm } = this.state
    const { intl, data } = this.props

    e.preventDefault()

    if (password !== confirm) {
      sendNotification('warning', intl, intl.formatMessage({ id: "password_confirmation" }))
      return
    }
    this.props.changePasswordUser(data._id, password, intl)
  }

  handleCancel = () => {
    this.props.handleHideChangePasswordUser()
  }


  render() {
    const { data, intl, newColor, isChangingPassword } = this.props
    const { password, isEnabled, confirm, allowChangePassword } = this.state
    if (!data) {
      return (
        <span>loading</span>
      )
    } else {
      return (
        <Form onSubmit={this.handleSubmit} layout="vertical" >
          <Form.Item>
            <span><b>{intl.formatMessage({ id: "name" })}:</b> {data.name} </span><br />
            <span><b>Email:</b> {data.email} </span><br />
            <span><b>{intl.formatMessage({ id: "role" })}:</b> {data.clientRoleTrad}</span>
          </Form.Item>
          <Form.Item>
            <span>{intl.formatMessage({ id: "new_password" })}</span>
            {/* <Input
              name="password"
              type="password"
              value={password}
              placeholder={intl.formatMessage({ id: "new_password" })}
              onChange={this.handleOnInputChange} /> */}
            <PasswordInput
              name="password"
              type="password"
              value={password}
              visibilityToggle={true}
              placeholder={intl.formatMessage({ id: "new_password" })}
              onChange={this.handleOnInputChange} />
          </Form.Item>
          <Form.Item>
            <span>{intl.formatMessage({ id: "confirm_new_password" })}</span>
            {/* <Input
              name="confirm"
              type="password"
              value={confirm}
              placeholder={intl.formatMessage({ id: "confirm_new_password" })}
              onChange={this.handleOnInputChange} /> */}
            <PasswordInput
              name="confirm"
              type="password"
              value={confirm}
              visibilityToggle={true}
              placeholder={intl.formatMessage({ id: "confirm_new_password" })}
              onChange={this.handleOnInputChange} />
          </Form.Item>
          {allowChangePassword ?
            <Form.Item>
              {!isEnabled && <Button loading={isChangingPassword} type="primary" htmlType="submit" disabled={!isEnabled}>{intl.formatMessage({ id: "change_password" })}</Button>}
              {isEnabled && <Button loading={isChangingPassword} type="primary" style={{ backgroundColor: newColor, borderColor: newColor }} htmlType="submit" disabled={!isEnabled}>{intl.formatMessage({ id: "change_password" })}</Button>}
              <Button
                type='deafult'
                style={{ color: newColor, borderColor: newColor, marginLeft: '10px' }}
                onClick={this.handleCancel}>{intl.formatMessage({ id: "cancel_button" })}<Icon type="close" /></Button>
            </Form.Item>
            : <Alert
              message={intl.formatMessage({ id: "unauthorized_change_password" })}
              type="info"
              style={{ marginBottom: 10 }} />}
        </Form>
      )
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.authUser.user,
  data: state.users.data.find(r => r.isChangePasswordSelected),
  isChangingPassword: state.users.isChangingPassword,

})

const mapDispatchToProps = {
  changePasswordUser
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword)))